module.exports = __webpack_public_path__ + "uploadPrivatesSample.a4f33c8632bf0e544a90ff8bb065ad22.svg";